import tinycolor from "tinycolor2";

export const getVisitedLinkColor = (linkColor: string): string => {
    const isBrowser = typeof document !== "undefined";
    return tinycolor(isBrowser ? getComputedStyle(document.documentElement).getPropertyValue(linkColor) : "#005b12")
        .desaturate(20)
        .lighten(20)
        .toString();
};
